import { render, staticRenderFns } from "./PendenciasMonitoramento360.vue?vue&type=template&id=616cb0a4&"
import script from "./PendenciasMonitoramento360.vue?vue&type=script&lang=js&"
export * from "./PendenciasMonitoramento360.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports